import {showError} from 'components/notify'
import {type Sb} from 'utils/db/supabaseClient'
import {match} from 'ts-pattern'
import {NotifyRowInsert} from './notifyTypes'

export {zNotifyCommentMode, zNotifyRow, zNotifyCommentCommon, zNotifyCfg} from './notifyTypes'
export type {NotifyCommentCommon, NotifyRow, NotifyRowInsert, NotifyType, NotifyCfg} from './notifyTypes'

export namespace Notify {
  export const create = async (sb: Sb, row: NotifyRowInsert) => await sb.from('notify').insert(row).select('*').single()

  export const clear = async (sb: Sb, id: string) => {
    const {error} = await sb.from('notify').update({archived: true}).match({id})
    if (error) showError(error, 'error clearing notification')
  }

  export const markRead = async (sb: Sb, id: string, read: boolean) => {
    const {error} = await sb.from('notify').update({read}).match({id})
    if (error) showError(error, 'error updating notification')
  }
}
